class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      const variantId = this.dataset.variantId; // Ensure the remove button has this data attribute

      // Update cart quantity to 0 for this item
      cartItems.updateQuantity(this.dataset.index, 0, undefined, variantId);

      // Clear the input directly when the remove button is clicked
      cartItems.clearSpecificProductListInput(variantId);

      // Update `quick-add-bulk` element to remove the `has-item` class
      this.updateQuickAddBulkClass(variantId);
    });
  }

  updateQuickAddBulkClass(variantId) {
    console.log(`Updating quick-add-bulk for variant ID: ${variantId}`);
  
    // Find **ALL** quick-add-bulk elements with matching variant ID
    const quickAddBulkElements = document.querySelectorAll(`quick-add-bulk[data-id="${variantId}"]`);
  
    if (quickAddBulkElements.length > 0) {
      quickAddBulkElements.forEach((element) => {
        console.log(`Removing "has-item" class from quick-add-bulk for variant ID: ${variantId}`);
        element.classList.remove('has-item');
      });
    } else {
      console.warn(`quick-add-bulk element not found for variant ID: ${variantId}`);
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') {
        return;
      }
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute('name'),
      event.target.dataset.quantityVariantId
    );
  }

  onCartUpdate() {
    const fetchCartSection = (url, sectionId) =>
      fetch(`${url}?section_id=${sectionId}`)
        .then((response) => response.text())
        .then((responseText) => new DOMParser().parseFromString(responseText, 'text/html'));
  
    if (this.tagName === 'CART-DRAWER-ITEMS') {
      fetchCartSection(routes.cart_url, 'cart-drawer')
        .then((html) => {
          const selectors = ['cart-drawer-items', '.cart-drawer__footer'];
          for (const selector of selectors) {
            const targetElement = document.querySelector(selector);
            const sourceElement = html.querySelector(selector);
            if (targetElement && sourceElement) {
              targetElement.replaceWith(sourceElement);
            }
          }
  
          // Reapply text color logic
          if (window.CartUtilities && window.CartUtilities.reapplyTextColorLogic) {
            window.CartUtilities.reapplyTextColorLogic();
          }
        })
        .catch(console.error);
    } else {
      fetchCartSection(routes.cart_url, 'main-cart-items')
        .then((html) => {
          const sourceQty = html.querySelector('cart-items');
          this.innerHTML = sourceQty.innerHTML;
  
          // Reapply text color logic
          if (window.CartUtilities && window.CartUtilities.reapplyTextColorLogic) {
            window.CartUtilities.reapplyTextColorLogic();
          }
        })
        .catch(console.error);
    }
  }  

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => response.text())
        .then((state) => {
            const parsedState = JSON.parse(state);
            const quantityElement =
                document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
            const items = document.querySelectorAll('.cart-item');

            if (parsedState.errors) {
                quantityElement.value = quantityElement.getAttribute('value');
                this.updateLiveRegions(line, parsedState.errors);
                return;
            }

            this.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartDrawerWrapper = document.querySelector('cart-drawer');
            const cartFooter = document.getElementById('main-cart-footer');

            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

            this.getSectionsToRender().forEach((section) => {
                const elementToReplace =
                    document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                elementToReplace.innerHTML = this.getSectionInnerHTML(
                    parsedState.sections[section.section],
                    section.selector
                );
            });

            // Reapply text color logic
            if (window.CartUtilities && window.CartUtilities.reapplyTextColorLogic) {
                window.CartUtilities.reapplyTextColorLogic();
            }

            // ✅ Remove "has-item" if quantity is 0
            if (variantId) {
                if (quantity === 0) {
                    this.updateQuickAddBulkClass(variantId); // Remove "has-item" class for all matching quick-add-bulk
                    this.clearSpecificProductListInput(variantId); // Also clear inputs for consistency
                } else {
                    this.syncSpecificProductListInput(variantId, quantity); // Sync quantity for existing inputs
                }
            }

            let message = '';
            const updatedValue = parsedState.items[line - 1] ? parsedState.items[line - 1].quantity : undefined;
            if (items.length === parsedState.items.length && updatedValue !== parseInt(quantityElement.value)) {
                if (typeof updatedValue === 'undefined') {
                    message = window.cartStrings.error;
                } else {
                    message = window.cartStrings.quantityError.replace('[quantity]', updatedValue);
                }
            }
            this.updateLiveRegions(line, message);

            const lineItem =
                document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
            if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
                cartDrawerWrapper
                    ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
                    : lineItem.querySelector(`[name="${name}"]`).focus();
            } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
            } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
                trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
            }

            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: parsedState, variantId: variantId });
        })
        .catch(() => {
            this.querySelectorAll('.loading__spinner').forEach((overlay) => overlay.classList.add('hidden'));
            const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
            errors.textContent = window.cartStrings.error;
        })
        .finally(() => {
            this.disableLoading(line);
        });
}

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError) lineItemError.querySelector('.cart-item__error-text').innerHTML = message;

    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus =
      document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading__spinner`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading__spinner`);

    cartItemElements.forEach((overlay) => overlay.classList.add('hidden'));
    cartDrawerItemElements.forEach((overlay) => overlay.classList.add('hidden'));
  }
  
  syncSpecificProductListInput(variantId, quantity) {
    console.log(`Sync Debugging for variantId: ${variantId}, New Quantity: ${quantity}`);

    // Look for the input across all potential sections (paginated or not)
    const productListInputs = document.querySelectorAll(`input[data-quantity-variant-id="${variantId}"]`);

    if (!productListInputs.length) {
        console.warn(`No input found for variantId: ${variantId} in any section`);
        return;
    }

    // Iterate over all matching inputs and update their values
    productListInputs.forEach((input) => {
        console.log('Found input:', input);
        console.log('Current DOM property value:', input.value);
        console.log('Current DOM attribute value:', input.getAttribute('value'));
        console.log('Expected new quantity:', quantity);

        // Update the input value
        input.value = quantity; // Update DOM property
        input.setAttribute('value', quantity); // Update DOM attribute

        // Log updated values
        console.log('Updated DOM property value:', input.value);
        console.log('Updated DOM attribute value:', input.getAttribute('value'));

        // Trigger an event if needed to reflect UI changes
        input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // ✅ Remove the "has-item" class if quantity is 0, otherwise ensure it's added
    const quickAddBulkElements = document.querySelectorAll(`quick-add-bulk[data-id="${variantId}"]`);

    if (quickAddBulkElements.length > 0) {
        quickAddBulkElements.forEach((element) => {
            if (parseInt(quantity, 10) === 0) {
                console.log(`❌ Removing "has-item" class from quick-add-bulk for variant ID: ${variantId}`);
                element.classList.remove('has-item');
            } else {
                console.log(`✅ Ensuring "has-item" class remains for quick-add-bulk with variant ID: ${variantId}`);
                element.classList.add('has-item');  // Ensure it's kept if quantity is above 0
            }
        });
    } else {
        console.warn(`quick-add-bulk element not found for variant ID: ${variantId}`);
    }
  }
  
  clearSpecificProductListInput(variantId) {
    console.log(`Clearing input for variantId: ${variantId}`);
  
    // Locate all inputs for the variant across the DOM
    const productListInputs = document.querySelectorAll(`input[data-quantity-variant-id="${variantId}"]`);
    
    if (!productListInputs.length) {
      console.warn(`No input found for variantId: ${variantId} in any section`);
      return;
    }
  
    // Iterate over all matching inputs and reset their values
    productListInputs.forEach((input) => {
      console.log('Found input:', input);
      console.log('Current DOM property value:', input.value);
      console.log('Current DOM attribute value:', input.getAttribute('value'));
  
      // Reset the input value and attribute
      input.value = 0; // Reset DOM property
      input.setAttribute('value', 0); // Reset DOM attribute
  
      // Log updated values
      console.log('Updated DOM property value to 0');
      console.log('Updated DOM attribute value to 0');
  
      // Trigger an event if needed to reflect UI changes
      input.dispatchEvent(new Event('input', { bubbles: true }));
    });

    // ✅ Also remove "has-item" from all matching `quick-add-bulk` elements
    const quickAddBulkElements = document.querySelectorAll(`quick-add-bulk[data-id="${variantId}"]`);
  
    if (quickAddBulkElements.length > 0) {
      quickAddBulkElements.forEach((element) => {
        console.log(`Removing "has-item" class from quick-add-bulk for variant ID: ${variantId}`);
        element.classList.remove('has-item');
      });
    } else {
      console.warn(`quick-add-bulk element not found for variant ID: ${variantId}`);
    }
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}